<script>
import {REAL_BRL} from '../../../../utils/helpers/money'
import {VMoney} from 'v-money'
import { VueMaskDirective as mask } from 'v-mask'

export default {
  name: 'AlterarValorLance',
  directives: {mask, money: VMoney},
  data () {
    return {
      money: REAL_BRL,
      valorFormatado: '',
      isOpen: false,
      lance: null
    }
  },
  computed: {
    valor () {
      return Number((this.valorFormatado.replace(/[^0-9,]/g, '')).replace(',', '.'))
    }
  },
  methods: {
    open (lance) {
      this.isOpen = true
      this.lance = lance
    },
    confirmaValor () {
      if (this.valor === 0) return
      this.$emit('novoValorLance', {lance: this.lance, valor: this.valor})
      this.reset()
    },
    reset () {
      this.valorFormatado = ''
      this.isOpen = false
    },
    close () {
      this.reset()
    }
  }
}
</script>

<template>
  <div class="novo-valor-input-container" v-if="isOpen">
    Insira o novo valor para o lance
    <input ref="input"
           v-model="valorFormatado"
           placeholder="R$ 0,00"
           v-money="money"
           autofocus
    />
    <div class="botoes-acao-novo-valor-lance">
      <button class="btn bg-primary" @click="confirmaValor">Confirmar</button>
      <button class="btn bg-danger" @click="close">Cancelar</button>
    </div>
  </div>
</template>

<style scoped>
.novo-valor-input-container {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 99999;
  background-color: rgba(255,255,255,0.75);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.novo-valor-input-container > input {
  font-size: 20px;
  margin-top: 15px;
  margin-bottom: 5px;
}
.botoes-acao-novo-valor-lance {
  width: 215px;
  display: flex;
  justify-content: space-between;
}
.botoes-acao-novo-valor-lance > button {
  width: calc(50% - 5px);
}

</style>



// WEBPACK FOOTER //
// AlterarValorLance.vue?76e7e8c2